import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Country } from '../models/country.model';
import { DeliveryOption } from '../models/delivery_option.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import deliveryOptionsQuery from 'src/app/graphql/queries/delivery_options.query.graphql'

@Injectable()
export class DeliveryOptionService extends GraphQLService<DeliveryOption> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  availableDeliveryOptions(country: Country): Observable<DeliveryOption[]> {
    return this.findAll(deliveryOptionsQuery, {iso: country.iso})
  }

}
